import React from 'react'
import HeaderHomeOne from '../partials/Headers/HeaderHomeOne'
import FooterHomeOne from '../partials/Footers/FooterHomeOne'
import BacktoTopCom from '../helpers/BackToTopCom'
import AcademicCollaboration from '../HomeThree/AcademicCollabrations'
import RandDContent from './RandDContent'
import RandDTeam from './RandDTeam'
import RandDGallery from './RandDGallery'


function RandDIntro() {
  return (
    <div
    style={{ overflowX: "hidden" }}>
        <HeaderHomeOne/>
        <RandDContent/>

        <AcademicCollaboration/>
        <RandDTeam/>
        <RandDGallery/>
        
        <FooterHomeOne/>
        <BacktoTopCom/>
    </div>
  )
}

export default RandDIntro